import { api, buildWpRestUrl, wpDirectPost, wpAdminPost } from 'utils';

const BASE = '/sta/v1/simulator';

// Cadastro: POST com corpo real via admin-post.php (fora do behavior
// wp-json do CloudFront). Consents gravados como inteiros no CMS.
export const postUser = async (data) =>
    wpAdminPost('sta_sim_cadastro', data);

export const postPage = async (data) =>
    wpDirectPost(`${BASE}/page`, data);

// Fallback robusto via admin-post.php (JSON correto) — usado após wpDirectPost
// Garante que respostas cheguem ao WP mesmo com limite de URL/query-string
export const savePageAnswers = async (simulationId, answers) =>
    wpAdminPost('sta_sim_save_page_answers', { simulation_id: simulationId, answers });

export const getPage = async (simulationId, page) => {
    const response = await api.get(buildWpRestUrl(`${BASE}/page`, `simulationId=${simulationId}&page=${page}`));
    return response;
};

export const postResult = async (data) =>
    wpDirectPost(`${BASE}/result`, {}, `simulationId=${data}`);

export const getResult = async (data) => {
    const response = await api.get(buildWpRestUrl(`${BASE}/result/print`, `simulationId=${data}`));
    return response;
};

export const postScoreNPS = async (simulationId, score) =>
    wpDirectPost(`${BASE}/nps`, {}, `simulationId=${simulationId}&score=${score}`);

export const updateUser = async (data) =>
    wpDirectPost(`${BASE}/users/update`, data);

// Atualiza cadastro + respostas no WP (update full) — dispara CRM no WP
// Usa admin-post.php (JSON correto) para garantir Temas preenchidos; fallback para wpDirectPost
export const updateContact = async (payload) => {
    try {
        return await wpAdminPost('sta_sim_contact', payload);
    } catch (e) {
        return await wpDirectPost(`${BASE}/contact`, payload);
    }
};

// Compatibilidade com fluxo antigo: alias para updateContact
export const sendContact = updateContact;

export const getLastId = async () => {
    const response = await api.get(buildWpRestUrl(`${BASE}/users/lastid`));
    return response;
};

export const sendEmail = async (data) =>
    wpDirectPost(`${BASE}/sendmail`, data);

export const getSegments = async () => {
    const response = await api.get(buildWpRestUrl(`${BASE}/segments`));
    return response.data || [];
};

export const getSchoolTypes = async () => {
    const response = await api.get(buildWpRestUrl(`${BASE}/school-types`));
    return response.data || [];
};
